import { InjectionToken } from '@angular/core';
import { LastApp } from '../../services/last-app-cookie.service';

/** Look of the page: the staff apps (CrownBase NXT, CrownStock) or the client portal (CrownDesk). */
export type SignedOutBrand = 'crownbase' | 'crowndesk';

export interface SignedOutConfig {
  /** Name of the app, shown in the logged-out text. */
  appName: string;
  /** Defaults to `crownbase`. */
  brand?: SignedOutBrand;
  /** Where staff get help signing in (e.g. a mailto: or helpdesk url); without it the help line is plain text. */
  helpUrl?: string;
  /** Where the user lands after logging in again when no valid return path is known. */
  startPath: string;
  /** Which app this is, remembered in the last-app cookie when the user logs in again. */
  lastApp?: LastApp;
  /** Parent domain for the last-app cookie; without it no cookie is written (e.g. on localhost). */
  lastAppCookieDomain?: string;
  /** Name of the last-app cookie, one per environment since they share the domain; defaults to `rc_last_app`. */
  lastAppCookieName?: string;
  /** Signed-out url of the Stock app, used to forward stale-login landings. */
  stockAppSignedOutUrl?: string;
}

export const SIGNED_OUT_CONFIG = new InjectionToken<SignedOutConfig>('SIGNED_OUT_CONFIG');
